/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AllergenDto } from './AllergenDto';
import {
    AllergenDtoFromJSON,
    AllergenDtoFromJSONTyped,
    AllergenDtoToJSON,
} from './AllergenDto';
import type { MenuBuilderComponentDto } from './MenuBuilderComponentDto';
import {
    MenuBuilderComponentDtoFromJSON,
    MenuBuilderComponentDtoFromJSONTyped,
    MenuBuilderComponentDtoToJSON,
} from './MenuBuilderComponentDto';
import type { OptionGroupDto } from './OptionGroupDto';
import {
    OptionGroupDtoFromJSON,
    OptionGroupDtoFromJSONTyped,
    OptionGroupDtoToJSON,
} from './OptionGroupDto';
import type { VariantInfo } from './VariantInfo';
import {
    VariantInfoFromJSON,
    VariantInfoFromJSONTyped,
    VariantInfoToJSON,
} from './VariantInfo';

/**
 * 
 * @export
 * @interface MenuItemVariantDto
 */
export interface MenuItemVariantDto {
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    variantLinkId: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItemVariantDto
     */
    price: number;
    /**
     * 
     * @type {number}
     * @memberof MenuItemVariantDto
     */
    takeawayPrice?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    description: string;
    /**
     * 
     * @type {Array<AllergenDto>}
     * @memberof MenuItemVariantDto
     */
    allergens: Array<AllergenDto>;
    /**
     * 
     * @type {Array<OptionGroupDto>}
     * @memberof MenuItemVariantDto
     */
    optionGroups: Array<OptionGroupDto>;
    /**
     * 
     * @type {VariantInfo}
     * @memberof MenuItemVariantDto
     */
    variantInfo?: VariantInfo;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    menuSectionId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    sectionProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    eposDisplayColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MenuItemVariantDto
     */
    allowOpenPrice?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    courseId?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    courseName?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItemVariantDto
     */
    courseSequence?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    giftCardId?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItemVariantDto
     */
    giftCardExpirationYears?: number;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    priceType?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    plu?: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemVariantDto
     */
    gtin?: string;
    /**
     * 
     * @type {number}
     * @memberof MenuItemVariantDto
     */
    abv?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MenuItemVariantDto
     */
    isComposite: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuItemVariantDto
     */
    autoApplyBundlePrice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuItemVariantDto
     */
    showComponentsInReceipt?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MenuItemVariantDto
     */
    showComponents?: boolean;
    /**
     * 
     * @type {Array<MenuBuilderComponentDto>}
     * @memberof MenuItemVariantDto
     */
    components?: Array<MenuBuilderComponentDto>;
}

/**
 * Check if a given object implements the MenuItemVariantDto interface.
 */
export function instanceOfMenuItemVariantDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "variantLinkId" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "allergens" in value;
    isInstance = isInstance && "optionGroups" in value;
    isInstance = isInstance && "isComposite" in value;

    return isInstance;
}

export function MenuItemVariantDtoFromJSON(json: any): MenuItemVariantDto {
    return MenuItemVariantDtoFromJSONTyped(json, false);
}

export function MenuItemVariantDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuItemVariantDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'variantLinkId': json['variantLinkId'],
        'name': json['name'],
        'price': json['price'],
        'takeawayPrice': !exists(json, 'takeawayPrice') ? undefined : json['takeawayPrice'],
        'description': json['description'],
        'allergens': ((json['allergens'] as Array<any>).map(AllergenDtoFromJSON)),
        'optionGroups': ((json['optionGroups'] as Array<any>).map(OptionGroupDtoFromJSON)),
        'variantInfo': !exists(json, 'variantInfo') ? undefined : VariantInfoFromJSON(json['variantInfo']),
        'menuSectionId': !exists(json, 'menuSectionId') ? undefined : json['menuSectionId'],
        'sectionProductId': !exists(json, 'sectionProductId') ? undefined : json['sectionProductId'],
        'eposDisplayColor': !exists(json, 'eposDisplayColor') ? undefined : json['eposDisplayColor'],
        'allowOpenPrice': !exists(json, 'allowOpenPrice') ? undefined : json['allowOpenPrice'],
        'courseId': !exists(json, 'courseId') ? undefined : json['courseId'],
        'courseName': !exists(json, 'courseName') ? undefined : json['courseName'],
        'courseSequence': !exists(json, 'courseSequence') ? undefined : json['courseSequence'],
        'giftCardId': !exists(json, 'giftCardId') ? undefined : json['giftCardId'],
        'giftCardExpirationYears': !exists(json, 'giftCardExpirationYears') ? undefined : json['giftCardExpirationYears'],
        'priceType': !exists(json, 'priceType') ? undefined : json['priceType'],
        'plu': !exists(json, 'plu') ? undefined : json['plu'],
        'gtin': !exists(json, 'gtin') ? undefined : json['gtin'],
        'abv': !exists(json, 'abv') ? undefined : json['abv'],
        'isComposite': json['isComposite'],
        'autoApplyBundlePrice': !exists(json, 'autoApplyBundlePrice') ? undefined : json['autoApplyBundlePrice'],
        'showComponentsInReceipt': !exists(json, 'showComponentsInReceipt') ? undefined : json['showComponentsInReceipt'],
        'showComponents': !exists(json, 'showComponents') ? undefined : json['showComponents'],
        'components': !exists(json, 'components') ? undefined : ((json['components'] as Array<any>).map(MenuBuilderComponentDtoFromJSON)),
    };
}

export function MenuItemVariantDtoToJSON(value?: MenuItemVariantDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'variantLinkId': value.variantLinkId,
        'name': value.name,
        'price': value.price,
        'takeawayPrice': value.takeawayPrice,
        'description': value.description,
        'allergens': ((value.allergens as Array<any>).map(AllergenDtoToJSON)),
        'optionGroups': ((value.optionGroups as Array<any>).map(OptionGroupDtoToJSON)),
        'variantInfo': VariantInfoToJSON(value.variantInfo),
        'menuSectionId': value.menuSectionId,
        'sectionProductId': value.sectionProductId,
        'eposDisplayColor': value.eposDisplayColor,
        'allowOpenPrice': value.allowOpenPrice,
        'courseId': value.courseId,
        'courseName': value.courseName,
        'courseSequence': value.courseSequence,
        'giftCardId': value.giftCardId,
        'giftCardExpirationYears': value.giftCardExpirationYears,
        'priceType': value.priceType,
        'plu': value.plu,
        'gtin': value.gtin,
        'abv': value.abv,
        'isComposite': value.isComposite,
        'autoApplyBundlePrice': value.autoApplyBundlePrice,
        'showComponentsInReceipt': value.showComponentsInReceipt,
        'showComponents': value.showComponents,
        'components': value.components === undefined ? undefined : ((value.components as Array<any>).map(MenuBuilderComponentDtoToJSON)),
    };
}

